import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
ChartJS.register(ArcElement, Tooltip, Legend);

const Navbar = () => {

  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Learning & Development");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="bg-black border-b border-blue-400 shadow-md sticky top-0 z-50">
      <div className="mx-auto px-2 py-3 flex flex-row justify-between">
        <div className="flex items-start gap-2 h-12">
            <div className="flex flex-col justify-start items-start text-left">
                <h1 className="text-lg lg:text-xl font-bold text-yellow-200">
                 ⚡EnergyHub ♻️
                </h1>            
                <h2 className="text-xs lg:text-sm font-bold text-gray-100">
                  Explore, Design & Track Solar Energy Systems
                </h2>

                <p className="text-[9px] lg:text-sm text-gray-200">
                  PhotVoltaic - Rooftop • Agri-PV • Industrial • Smart Energy Insights
                </p>  
            </div>
        </div>

        <div className="p-2 flex rounded">
          <div className="flex gap-1">
            {isLoggedIn ? (
              <>
                <div className="p-1 text-xs lg:text-sm text-teal-300">
                  {userName}
                </div>

                <button
                  onClick={handleLogout}
                  className="p-1 w-6 text-xs lg:text-sm rounded-md
                            bg-red-600 hover:bg-red-700 transition"
                  title="Logout"
                >
                  ⏻
                </button>
              </>
            ) : (
              <button
                onClick={() => navigate("/login")}
                className="px-1 py-1 rounded-full border border-gray-700
                          text-xs lg:text-sm text-gray-200 hover:bg-gray-800"
              >
                🔑
              </button>
            )}
          </div>
        </div>

      </div>
    </nav>
  );
};

const navItems = [

  // ☀️ SOLAR CORE
  { to: "/solar/rooftop", label: "Rooftop Solar", icon: "🏠☀️", bg: "bg-yellow-600" },
  { to: "/solar/utility", label: "Utility Solar", icon: "🏭☀️", bg: "bg-orange-600" },
  { to: "/solar/agri-pv", label: "Agri-PV", icon: "🌾☀️", bg: "bg-green-700" },
  { to: "/solar/analytics", label: "Analytics", icon: "📊☀️", bg: "bg-purple-700" },
  { to: "/solar/calculator", label: "PV Calculator", icon: "🧮☀️", bg: "bg-red-700" },
  { to: "/solar/storage", label: "Battery", icon: "🔋☀️", bg: "bg-gray-700" },
  { to: "/solar/msme", label: "MSME Solar", icon: "🏢☀️", bg: "bg-teal-700" },

  // 🏭 BUSINESS / BRANDS
  { to: "/orderflow-products/platecraft/innovative", label: "Innovative", icon: "✨", bg: "bg-red-900" },
  { to: "/orderflow-products/platecraft/hero", label: "Market Trends", icon: "📊", bg: "bg-red-800" },
  { to: "/orderflow-products/platecraft", label: "Marketplace", icon: "🛒", bg: "bg-red-800" },
  { to: "/orderflow-products/platecraft/hero", label: "Hero Products", icon: "⭐", bg: "bg-blue-800" },

  // 🅰️ ACPL EXPANSION
  { to: "/orderflow-products/platecraft/azcor", label: "ACPL", icon: "🅰️", bg: "bg-pink-600" },
  { to: "/acpl/service-points", label: "Service Points", icon: "📍🔧", bg: "bg-pink-700" },
  { to: "/acpl/besure", label: "beSure", icon: "🛡️✅", bg: "bg-green-600" },

  // 🔋 POWER HUB CITY (Replaced Khurja)
  { to: "/energy/delhi-power-hub", label: "Delhi Power Hub", icon: "🏙️🔋", bg: "bg-blue-600" },

  // ⚡ PLATFORM FEATURES
  { to: "/msmetube", label: "energyTube", icon: "☀️⚡", bg: "bg-red-700" },
  { to: "", label: "Photovoltaic", icon: "☀️🔋", bg: "bg-red-700" },
  { to: "/life-chronicles-home", label: "EnergyLogs", icon: "📝", bg: "bg-red-700" },

  // 🎯 ENGAGEMENT
  { to: "/photocanwin", label: "Winning Photo", icon: "📸", bg: "bg-teal-600" },
  { to: "/kharchojeeto", label: "KharchoJeeto", icon: "🪞", bg: "bg-teal-600" },

  // 💰 TOOLS
  { to: "/orderflow-earning-estimator", label: "DigitalIncome", icon: "🪙", bg: "bg-red-700" },
  { to: "/energyhub-personalize", label: "Personalize", icon: "🎨", bg: "bg-red-700" },

  // 👤 USER + AI
  { to: "", label: "My Account", icon: "🧑‍💼", bg: "bg-blue-600" },
  { to: "/agenticsim", label: "EnergyHub AI", icon: "🤖", bg: "bg-red-700" },
  { to: "", label: "Digital Twin", icon: "🌐", bg: "bg-red-700" },
];

const TopNav = () => {
  return (
    <section className="flex flex-col px-4 text-white bg-black py-0 gap-1 mt-2 mb-1">
      <ul className="grid grid-cols-3 lg:grid-cols-8 gap-0.5">
        {navItems.map((item, index) => (
          <li key={index}>
            <Link
              to={item.to}
              className={`
                w-full h-8
                flex items-center justify-center gap-1
                rounded-lg
                ${item.bg} hover:opacity-90
                text-gray-50 hover:text-yellow-200
                text-xs lg:text-sm
                leading-tight text-center
                transition-all duration-200
              `}
            >
              <span className="text-sm lg:text-lg">{item.icon}</span>
              <span className="truncate">{item.label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};

const Hero = () => {
  return (
    <section
      id="home"
      className="relative flex flex-col items-center justify-center 
                h-[45vh] lg:h-[55vh] px-4 mx-4 text-white text-center 
                overflow-hidden rounded-xl"
    >

      {/* 🌌 Background Layer */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-blue-900" />

      {/* ⚡ Energy Glow Effect */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_30%,rgba(255,215,0,0.25),transparent_60%)]" />

      {/* ⚡ Grid Lines (Tech Feel) */}
      <div className="absolute inset-0 opacity-10 bg-[linear-gradient(to_right,white_1px,transparent_1px),
                          linear-gradient(to_bottom,white_1px,transparent_1px)] bg-[size:40px_40px]" />

      {/* 🔥 Content */}
      <div className="relative z-10 flex flex-col items-center gap-3">

        {/* Main Title */}
        <h1 className="text-3xl lg:text-5xl font-extrabold text-yellow-300 tracking-wide">
          ☀️⚡ EnergyHub
        </h1>
        <div className="px-4 py-1 rounded-full 
                          bg-green-600/20 border border-green-400/40
                          text-green-300 text-xs lg:text-sm 
                          flex items-center gap-2 backdrop-blur-sm">
            🌍 ⚡ ACPL powering global transition to Solar & Backup Energy
          </div>
        {/* Tagline */}
        <h2 className="text-sm lg:text-xl text-gray-200 font-medium">
          Solar • UPS • Inverter • Smart Energy Systems
        </h2>

        {/* Subtext */}
        <p className="text-xs lg:text-base text-gray-400">
          Power your home, business & farms with intelligent solar, battery backup and energy optimization solutions.
        </p>

        {/* CTA Buttons */}
        <div className="grid grid-cols-2 gap-1">
          <button className="text-xs lg:text-sm w-56 lg:w-64 px-1 py-1 rounded-md
                            bg-yellow-500 text-black font-semibold 
                            hover:bg-yellow-400 transition">
            ⚡ Calculate Savings
          </button>
          <button className="text-xs lg:text-sm w-56 lg:w-64 px-1 py-1 rounded-md 
                            border border-gray-400 
                            hover:border-yellow-300 hover:text-yellow-200 
                            transition">
            🔋 Explore Systems
          </button>
        </div>
      </div>
    </section>
  );
};

// Simple market score for eco & trend preferences
const getScoreMeta = (score) => {
  if (score >= 90) return { label: "Excellent", color: "#16a34a" };
  if (score >= 70) return { label: "Good", color: "#22c55e" };
  if (score >= 50) return { label: "Average", color: "#eab308" };
  return { label: "Needs Attention", color: "#dc2626" };
};

const ScoreChart = ({ score, chartRef }) => {
  const meta = getScoreMeta(score);

  const data = {
    labels: ["Efficiency", "Scalability", "Sustainability", "Gap"],
    datasets: [
      {
        data: [score * 0.4, score * 0.3, score * 0.2, 100 - score],
        backgroundColor: [meta.color, "#f59e0b", "#3b82f6", "#1f2937"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    plugins: { legend: { display: false } },
    cutout: "70%",
  };

  return (
    <div className="relative w-48 h-48 mx-auto">
      <Pie data={data} options={options} />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
        <div className="text-2xl font-bold">{score}%</div>
        <div className="text-xs text-gray-300">{meta.label}</div>
      </div>
    </div>
  );
};

const PersonalizeEnergyHub = () => {
  const [answers, setAnswers] = useState([]);
  const [score, setScore] = useState(null);
  const chartRef = useRef(null);

  const questions = [
    {
      emoji: "🏠",
      text: "Installation type?",
      options: ["Residential", "Commercial", "Industrial", "Agricultural"],
      score: [20, 25, 30, 25],
    },
    {
      emoji: "☀️",
      text: "Sunlight availability?",
      options: ["High", "Medium", "Low"],
      score: [30, 20, 10],
    },
    {
      emoji: "🔋",
      text: "Need battery storage?",
      options: ["Yes", "No"],
      score: [25, 10],
    },
    {
      emoji: "💰",
      text: "Budget?",
      options: ["< ₹1L", "₹1L–₹5L", "₹5L+"],
      score: [10, 20, 30],
    },
  ];

  const handleSelect = (qIndex, optionIndex) => {
    setAnswers(prev => {
      const updated = [...prev];
      updated[qIndex] = optionIndex;
      return updated;
    });
  };

  const calculateScore = () => {
    let total = 0;
    questions.forEach((q, i) => {
      const ans = answers[i];
      if (ans != null) total += q.score[ans];
    });
    setScore(total);
  };

  return (
    <section id="personalize" className="py-4 px-4 bg-black text-white max-w-3xl mx-auto space-y-4 rounded-2xl border border-gray-700">
      <h2 className="text-lg lg:text-xl text-yellow-200 font-bold mb-2 text-center">
        Personalize Your EnergyHub Preferences
      </h2>

      {questions.map((q, qIndex) => {
        const selected = answers[qIndex];
        return (
          <div key={qIndex} className="bg-gray-900 p-3 rounded-lg flex flex-col gap-2">
            <h3 className="text-sm lg:text-lg font-semibold text-cyan-300">{q.emoji} {q.text}</h3>
            <div className="flex flex-wrap gap-2">
              {q.options.map((opt, optIndex) => (
                <button
                  key={optIndex}
                  onClick={() => handleSelect(qIndex, optIndex)}
                  className={`px-3 py-1 text-xs lg:text-sm rounded-md border transition font-medium
                    ${selected === optIndex ? "bg-red-600 border-red-500 shadow-sm" : "bg-gray-700 border-gray-600 hover:bg-gray-600"}`}
                >
                  {opt}
                </button>
              ))}
            </div>
          </div>
        );
      })}

      <button
        onClick={calculateScore}
        className="mt-3 w-full bg-red-600 hover:bg-red-700 px-4 py-2 rounded-md font-semibold text-white"
      >
        Submit Preferences
      </button>

      {score !== null && <ScoreChart score={score} chartRef={chartRef} />}
    </section>
  );
};

const PhotovoltaicSection = () => {
  return (
    <section className="py-6 px-4 bg-gray-900 text-white rounded-2xl max-w-4xl mx-auto mt-4">
      <h2 className="text-xl font-bold text-yellow-300 mb-4 text-center">
        ☀️🔋 Photovoltaic Systems Overview
      </h2>

      <div className="grid md:grid-cols-3 gap-4">

        <div className="bg-black p-4 rounded-lg border border-gray-700">
          <h3 className="text-green-400 font-semibold">🏠 Rooftop PV</h3>
          <p className="text-sm text-gray-300">
            Ideal for homes & small businesses. Reduces electricity bills.
          </p>
        </div>

        <div className="bg-black p-4 rounded-lg border border-gray-700">
          <h3 className="text-blue-400 font-semibold">🏭 Utility Scale</h3>
          <p className="text-sm text-gray-300">
            Large solar farms generating megawatts of power.
          </p>
        </div>

        <div className="bg-black p-4 rounded-lg border border-gray-700">
          <h3 className="text-yellow-400 font-semibold">🌾 Agri-PV</h3>
          <p className="text-sm text-gray-300">
            Dual land use: farming + solar generation.
          </p>
        </div>

      </div>
    </section>
  );
};

export default function EnergyHubHome() {
  return (
    <div className="bg-black text-white min-h-screen">
      <Navbar />      
      <TopNav />
      <Hero />
      <PhotovoltaicSection />
      <PersonalizeEnergyHub />
    </div>
  );
}
